import axios from 'axios';
import { processResponse } from '../../../util/service-util';
import { ICustomer } from './customer-type';

export const getCustomers = () =>
  axios.get<ICustomer[]>(`/api/customer`).then(response => processResponse(response));



// WEBPACK FOOTER //
// ./src/modules/customers/parts/customer-service.ts